import { combineReducers } from 'redux'

import selfServiceSSO from 'reducers/accounts/selfServiceSsoActions'
import application from './application'
import fundsDistribution from './fundsDistribution'
import submittable from './submittable'
import csr from './csr'
import accounts from './accounts'
import ablePortal from './ablePortal'
import authorizationManagement from './authorizationManagement'
import lookUp from './lookUp'

const rootReducer = combineReducers({
  application,
  fundsDistribution,
  submittable,
  csr,
  accounts,
  ablePortal,
  authorizationManagement,
  selfServiceSSO,
  lookUp,
})

export default rootReducer
